import { render, staticRenderFns } from "./AnomalyBookedButAvailable.vue?vue&type=template&id=74607f3e&"
import script from "./AnomalyBookedButAvailable.vue?vue&type=script&lang=js&"
export * from "./AnomalyBookedButAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports